import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/Reveal";
import { TEAM, TEAM_STATS } from "@/data/content";

const EASE = [0.16, 1, 0.3, 1];

const Risorse = () => {
  const { lang, t } = useLang();
  const cols = t("risorse.cols");

  return (
    <section data-testid="risorse-section" className="relative bg-cream text-forest py-20 sm:py-28">
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-12">
          {/* Table */}
          <div className="lg:col-span-7">
            <Reveal>
              <div className="grid grid-cols-12 pb-3 border-b-2 border-forest/20 text-[0.65rem] font-bold uppercase tracking-[0.18em] text-forest/50">
                <span className="col-span-5">{cols[0]}</span>
                <span className="col-span-5">{cols[1]}</span>
                <span className="col-span-2 text-right">{cols[2]}</span>
              </div>
            </Reveal>
            {TEAM.map((r, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: -12 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, ease: EASE, delay: i * 0.05 }}
                className="grid grid-cols-12 items-center py-4 border-b border-forest/10 group hover:bg-cream-2 transition-colors duration-300"
                data-testid={`team-row-${i}`}
              >
                <span className="col-span-5 text-sm text-forest/55 uppercase tracking-wider pl-1">{r[lang].sector}</span>
                <span className="col-span-5 text-base font-medium text-forest">{r[lang].role}</span>
                <span className="col-span-2 text-right font-display text-3xl font-light text-forest-deep pr-1 [font-variant-numeric:lining-nums] [font-feature-settings:'lnum']">{r.n}</span>
              </motion.div>
            ))}
          </div>

          {/* Numbers band */}
          <div className="lg:col-span-5">
            <Reveal delay={0.15}>
              <div className="bg-forest-deep text-cream rounded-tr-[2.5rem] rounded-bl-[2.5rem] p-8 lg:p-10 h-full flex flex-col justify-between">
                <div>
                  <h3 className="font-display text-3xl font-medium leading-tight">{t("risorse.numbersTitle")}</h3>
                  <p className="text-cream/70 font-light leading-relaxed mt-4 text-sm">{t("risorse.numbersText")}</p>
                </div>
                <div className="grid grid-cols-3 gap-4 mt-10 border-t border-cream/15 pt-6">
                  {TEAM_STATS.map((s) => (
                    <div key={s.value}>
                      <div className="font-display text-3xl sm:text-4xl font-light text-gold">{s.value}</div>
                      <div className="text-[0.6rem] uppercase tracking-widest text-cream/55 mt-1">{s[lang]}</div>
                    </div>
                  ))}
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Risorse;
